export type CreditCardValidationError = 'CVC_DECLINED' | 'CARD_EXPIRED' | 'EXPIRY_DATE_INVALID' | 'INVALID_CARD_NUMBER';
